/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { KentStatus } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * StatusAPIApi - axios parameter creator
 * @export
 */
export const StatusAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets the current status of the KENT ↔ Kentroller link for a cluster.
         * @summary Gets Kentroller status for a cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusAPIGetKentStatus: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('statusAPIGetKentStatus', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('statusAPIGetKentStatus', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/status`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatusAPIApi - functional programming interface
 * @export
 */
export const StatusAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatusAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets the current status of the KENT ↔ Kentroller link for a cluster.
         * @summary Gets Kentroller status for a cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statusAPIGetKentStatus(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KentStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statusAPIGetKentStatus(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatusAPIApi.statusAPIGetKentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatusAPIApi - factory interface
 * @export
 */
export const StatusAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatusAPIApiFp(configuration)
    return {
        /**
         * Gets the current status of the KENT ↔ Kentroller link for a cluster.
         * @summary Gets Kentroller status for a cluster.
         * @param {StatusAPIApiStatusAPIGetKentStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statusAPIGetKentStatus(requestParameters: StatusAPIApiStatusAPIGetKentStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<KentStatus> {
            return localVarFp.statusAPIGetKentStatus(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for statusAPIGetKentStatus operation in StatusAPIApi.
 * @export
 * @interface StatusAPIApiStatusAPIGetKentStatusRequest
 */
export interface StatusAPIApiStatusAPIGetKentStatusRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof StatusAPIApiStatusAPIGetKentStatus
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof StatusAPIApiStatusAPIGetKentStatus
     */
    readonly clusterId: string
}

/**
 * StatusAPIApi - object-oriented interface
 * @export
 * @class StatusAPIApi
 * @extends {BaseAPI}
 */
export class StatusAPIApi extends BaseAPI {
    /**
     * Gets the current status of the KENT ↔ Kentroller link for a cluster.
     * @summary Gets Kentroller status for a cluster.
     * @param {StatusAPIApiStatusAPIGetKentStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusAPIApi
     */
    public statusAPIGetKentStatus(requestParameters: StatusAPIApiStatusAPIGetKentStatusRequest, options?: RawAxiosRequestConfig) {
        return StatusAPIApiFp(this.configuration).statusAPIGetKentStatus(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }
}

